export const isIOS =
  typeof window !== 'undefined' &&
  (/iPad|iPhone|iPod/.test(navigator.platform) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1));

export const isIOSNativeApp =
  typeof window !== 'undefined' &&
  Boolean(
    window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.audio
  );

export const isAndroidNativeApp =
  typeof window !== 'undefined' &&
  Boolean(window.Android && window.Android.sendMessage);

export const isWebApp =
  !isIOSNativeApp && !isAndroidNativeApp && typeof window !== 'undefined';

// Current just Android
export const isNativeAppWithStateV1 =
  isAndroidNativeApp && Boolean(window.Android?.getState);

export const isPlaylistSupported = isNativeAppWithStateV1 || isWebApp;

export const isSleepTimerSupported = isNativeAppWithStateV1 || isWebApp;

export const platform = isIOSNativeApp ? 'iOS' : isAndroidNativeApp ? 'Android' : 'Web';

export const isLocalDevelopment =
  typeof window !== 'undefined' && location.protocol === 'http:';
